<template>
    <el-option
      :key="source.uid"
      :value="(source.type =='1' || source.type == '2') ? source.name : source.id"
      :label="source.name"
      >
    </el-option>
</template>

<script>
export default {
    name: 'item-component',
    props: {
        index: {
            type: Number
        },
        source: {
            type: Object,
            default () {
                return {}
            }
        },
        name: {
            type: String
        },
        value: {
            type: String
        },
        type: {
            type: String
        }
    },
    computed: {
        getLabel() {
            let cur_platName = this.source.plat_name ? `(${this.source.plat_name})` : ''
            let cur_packName = this.source.type == 4 ? `${this.source.subproject_content ? `${this.source.subproject_content}` : ''}` : ''
            let cur_id = ''
            if(this.source.type != 1 && this.source.type != 2) {
                cur_id = `-${this.source.id}`
            }
            return `${this.source.name}${cur_id}${cur_packName}${cur_platName}`
        }
    }
}
</script>
